module.exports = __webpack_public_path__ + "assets/img/36_18_big.767027ef.jpg";